import { render, staticRenderFns } from "./tableOrders.vue?vue&type=template&id=78da06e7&scoped=true"
import script from "./tableOrders.vue?vue&type=script&lang=js"
export * from "./tableOrders.vue?vue&type=script&lang=js"
import style0 from "./tableOrders.vue?vue&type=style&index=0&id=78da06e7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78da06e7",
  null
  
)

export default component.exports